<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2>
      <v-list two-line class="scroll-y" style="max-height: 400px" v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <template v-for="(item, index) in articles">
          <v-list-tile
            :key="item._url"
            avatar
            @click="goToArticle(item._url)"
          >
            <v-list-tile-avatar color="grey" tile>
              <img v-if="item._image_url" :src="item._image_url">
              <v-icon v-else dark>block</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item._domain }}</v-list-tile-title>
              <v-list-tile-sub-title v-html="item._title"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-avatar @click.stop="backtrack(item._id, 'article', item._date_published)" color="secondary" size="40" class="pointer">
              <v-btn icon>
                <v-icon>fas fa-backward</v-icon>
              </v-btn>
            </v-list-tile-avatar>
            <v-list-tile-avatar @click.stop="selectedArticle = item._id; deleteArticleConfirmationDialog = true" color="secondary" size="40" class="pointer">
              <v-btn icon>
                <v-icon>fas fa-trash</v-icon>
              </v-btn>
            </v-list-tile-avatar>
            <v-list-tile-avatar color="secondary" size="40">
              <span class="pointer accent--text caption">{{ numberOfTweets(item._tweeted_count) }}</span>
            </v-list-tile-avatar>
          </v-list-tile>
          <v-divider v-if="articles[index+1]"></v-divider>
        </template>
      </v-list>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
    </v-flex>
    <v-dialog
      v-model="deleteArticleConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete article?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteArticle" :loading="deleteLoading">Confirm</v-btn>
          <v-btn @click="deleteArticleConfirmationDialog = false; selectedArticle = null" :disabled="deleteLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style scoped>
.alternateState{
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.blurClass{
  filter: blur(5px);
  -webkit-filter: blur(5px);
}
</style>
<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import numeral from 'numeral'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      articles: [],
      deleteArticleConfirmationDialog: false,
      selectedArticle: null,
      deleteLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    deleteArticle () {
      this.deleteLoading = true
      axios.all([
        this.$store.dispatch('deleteArticleById', {id: this.selectedArticle, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedArticle = null
          this.deleteArticleConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteLoading = false
      })).catch((err) => {
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    backtrack: function (id, type, date) {
      let query = this.$route.query
      query.id = id
      query.type = type
      query.date = date
      query.connections = ['story']
      query.objects = ['article']
      this.$router.push({ path: '/backtracker', query: query })
    },
    numberOfTweets: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    goToArticle (url) {
      window.open(url, '_blank')
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getArticles', this.getQuery({sortBy: '_tweeted_count', order: 'desc', pageSize: 30}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          let temp = []
          for (var t = 0; t < r1.data.payload.length; t++) {
            if (r1.data.payload[t]._title != null) {
              temp.push(r1.data.payload[t])
            }
          }
          this.articles = temp
          if (temp.length > 0) {
            this.dataState = 'ready'
          } else {
            this.dataState = 'noData'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/rankings/ArticlesByNumberOfRetweets.vue